import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { extractNumber, PagedList, PromoBannerModel } from 'hx-services';
import { HxCitySelectComponent, HxPagedListDirective } from 'hx-components';
import { PromoBannerService } from '@adm-web-app/services/promo-banner.service';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { NzAffixComponent } from 'ng-zorro-antd/affix';
import { NzPageHeaderComponent, NzPageHeaderExtraDirective, NzPageHeaderSubtitleDirective, NzPageHeaderTitleDirective } from 'ng-zorro-antd/page-header';
import { NzButtonComponent, NzButtonGroupComponent } from 'ng-zorro-antd/button';

import { NzIconDirective } from 'ng-zorro-antd/icon';
import { NzCollapseComponent, NzCollapsePanelComponent } from 'ng-zorro-antd/collapse';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { FormsModule } from '@angular/forms';
import { NzTableCellDirective, NzTableComponent, NzTbodyComponent, NzThAddOnComponent, NzTheadComponent, NzThMeasureDirective, NzTrDirective } from 'ng-zorro-antd/table';
import { JsonPipe, NgFor, NgIf } from '@angular/common';
import { NzTagComponent } from 'ng-zorro-antd/tag';
import { NzWaveDirective } from 'ng-zorro-antd/core/wave';
import { NzPopconfirmDirective } from 'ng-zorro-antd/popconfirm';

@Component({
    selector: 'hc-promo-list',
    templateUrl: './promo-banner-list.component.html',
    styleUrls: ['./promo-banner-list.component.less'],
  imports: [TranslocoDirective, NzAffixComponent, NzPageHeaderComponent, NzPageHeaderTitleDirective, NzPageHeaderSubtitleDirective, NzPageHeaderExtraDirective, NzButtonComponent, RouterLink, NzIconDirective, NzCollapseComponent, NzCollapsePanelComponent, NzRowDirective, NzColDirective, HxCitySelectComponent, FormsModule, NzTableComponent, NzTheadComponent, NzTrDirective, NzTableCellDirective, NzThMeasureDirective, NzThAddOnComponent, NzTbodyComponent, NgFor, NgIf, NzTagComponent, NzButtonGroupComponent, NzWaveDirective, NzPopconfirmDirective, JsonPipe, TranslocoPipe]
})
export class PromoBannerListComponent extends HxPagedListDirective<PromoBannerModel> implements OnInit {
  isLoading: {
    banners: { [key: number]: boolean }
  } = {
    banners: {}
  };
  filter: {
    cityId?: number
  } = {};

  constructor(
    override router: Router,
    override aRoute: ActivatedRoute,
    private promoBannerService: PromoBannerService,
  ) {
    super(router, aRoute);
  }

  ngOnInit() {
    this.aRoute.queryParamMap.pipe(takeUntil(this.$destroyed))
      .subscribe(paramMap => {
        this.filter.cityId = extractNumber('cityId', paramMap);
        super.load(paramMap);
      });
  }

  applyFilters() {
    this.router.navigate([], {
      relativeTo: this.aRoute,
      queryParams: {...this.filter},
      queryParamsHandling: 'merge',
    });
  }

  protected loadList(): Promise<PagedList<PromoBannerModel>> {
    return this.promoBannerService.getPromoBanners({
      ...this.filter, ...{
        page: this.page,
        limit: this.limit,
        sort: this.getSortParams(),
      }
    });
  }

  remove(el: PromoBannerModel): void {
    this.promoBannerService.removePromo(el.id)
      .then(() => this.loadData());
  }
}
